define('views/components/lead/lead',['require','backbone','text!templates/components/lead/lead.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/lead/lead.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'lead-item',

        initialize: function () {
            if (this.model.get('progress_status') == 6) {
                this.$el.addClass('bg-danger-light');
            } else if (!_.isEmpty(this.model.get('customer_object'))) {
                this.$el.addClass('bg-success-light');
            } else if (!_.isEmpty(this.model.get('reseller_object'))) {
                this.$el.addClass('bg-warning-light');
            }
        }
    });
});
